import { render, staticRenderFns } from "./HIK_loss_attachment-modal.vue?vue&type=template&id=54ae274a&scoped=true"
import script from "./HIK_loss_attachment-modal.vue?vue&type=script&lang=js"
export * from "./HIK_loss_attachment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae274a",
  null
  
)

export default component.exports